export default {
  admin: 'admin',
  accountant: 'accountant',
  projectManager: 'pm',
  teamLead: 'lead',
};
